module.exports = __webpack_public_path__ + "img/zt_pic3.fc3a0c37.jpg";